<template>
  <v-dialog
    :scrollable="options.scrollable"
    :persistent="options.persistent"
    v-model="dialog"
    :max-width="options.width"
    @keyup.esc.stop="cancel"
    @keydown.enter="agree()"
    style="z-index: 7"
    tabindex="1"
  >
    <v-card class="confirm-card">
      <div v-if="toolbar" class="confirm-title">
        <v-icon left color="white" size="28">mdi-information</v-icon>
        <span class="confirm-title-text">{{ title }}</span>
      </div>
      <v-card-text
        class="confirm-text"
        :style="{
          'white-space': options.whiteSpace
        }"
        v-html="message || ''"
      >
      </v-card-text>
      <slot></slot>
      <v-card-actions class="confirm-actions pr-5 pb-5 pl-5">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!options.hideCancel"
          class="confirm-cancel-btn"
          elevation="0"
          @click.stop="cancel"
        >
          <v-icon left small>mdi-close</v-icon>
          {{ options.cancelText }}
        </v-btn>
        <v-btn
          v-if="options.confirmVisible"
          :disabled="confirmDisabled"
          id="success"
          class="confirm-ok-btn ml-2"
          ref="confirmRef"
          @keyup.enter="agree"
          @click.stop="agree"
          elevation="0"
        >
          <v-icon left small>mdi-check</v-icon>
          {{ options.confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

const defaults = {
  color: 'primary',
  width: 290,
  zIndex: 200,
  persistent: true,
  confirmVisible: true,
  confirmText: 'Ok',
  cancelText: 'Cancel',
  scrollable: false,
  maxHeight: 900,
  whiteSpace: true
}

export default {
  props: ['toolbar', 'confirmDisabled'],
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: defaults,
    confirmDis: true
  }),
  methods: {
    open (title, message, options) {
      this.$nextTick(() => {
        this.dialog = true
        this.title = title
        this.message = message
      })

      this.options = { ...defaults, ...options }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.$emit('selection', true)
      this.resolve(true)
    },
    cancel (e) {
      this.options = defaults
      this.resolve(false)
      this.$emit('cancel')
      e.stopPropagation()
      this.dialog = false
    },
    close () {
      this.dialog = false
      this.$emit('cancel')
    },
    handleKeyEvents (e) {
      e = e || window.event

      switch (e.keyCode) {
        case 13: { // enter
          this.agree()
        }
      }
    }
  }
}
</script>
<style scoped>
/* Confirm Card */
.confirm-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.12) !important;
}

/* Confirm Title - Info Style */
.confirm-title {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 20px 24px !important;
  display: flex !important;
  align-items: center !important;
  position: relative;
}

.confirm-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  pointer-events: none;
}

.confirm-title-text {
  color: white !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

/* Confirm Text */
.confirm-text {
  padding: 16px 24px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 15px !important;
  line-height: 1.6 !important;
}

/* Confirm Actions */
.confirm-actions {
  padding: 16px 24px 24px 24px !important;
}

/* Confirm OK Button - Soft Success Style */
.confirm-ok-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #4CAF50 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(76, 175, 80, 0.15) !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.confirm-ok-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  border-color: rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px);
}

.confirm-ok-btn:disabled {
  opacity: 0.5 !important;
  background: rgba(245, 245, 245, 0.8) !important;
  border-color: rgba(200, 200, 200, 0.3) !important;
  color: rgba(158, 158, 158, 0.6) !important;
}

.confirm-ok-btn .v-icon {
  color: #4CAF50 !important;
  font-size: 18px !important;
}

.confirm-ok-btn:disabled .v-icon {
  color: rgba(158, 158, 158, 0.6) !important;
}

/* Confirm Cancel Button - Soft Danger Style */
.confirm-cancel-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #F44336 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(244, 67, 54, 0.15) !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 18px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.confirm-cancel-btn:hover {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  border-color: rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px);
}

.confirm-cancel-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}
</style>
